import { useParams } from "react-router-dom";
import AllCheckSeletivaManausOlimpica2024 from "./tournament/check-seletiva-manaus-olimpica-2024";
import AllCheckViiiReiERainhaDaPraiaBeachWrestilingManausAmazonas2024 from "./tournament/check-viii-rei-e-rainha-da-praia-beach-wrestiling-manaus-amazonas-2024";
import AllCheckCopaAmizadeDeJiuJitsu2024 from "./tournament/check-copa-amizade-de-jiu-jitsu-2024";
import AllCheckCopaMestreAcaiDeJiuJitsu2024 from "./tournament/check-copa-mestre-acai-de-jiu-jitsu-2024y";
import AllCheckXxxiiCopaOrleyLobatoDeJiuJitsu from "./tournament/check-xxxii-copa-orley-lobato-de-jiu-jitsu";
import AllCheckIOrixicombatOpenJiuJitsu from "./tournament/check-i-orixicombat-open-jiu-jitsu";
import AllCheckJiuJitsuLaranjaEVerdeJuntos from "./tournament/check-jiu-jitsu-laranja-e-verde-juntos";
import AllCheckCopaLoboBravoCresolDeJiuJitsu from "./tournament/check-copa-lobo-bravo-cresol-de-jiu-jitsu";
import AllCheckIvOpenTerraSantaDeJiuJitsu from "./tournament/check-iv-open-terra-santa-de-jiu-jitsu";
import AllCheckViiOpenAmazonasTopTeamDeJiuJitsu from "./tournament/check-vii-open-amazonas-top-team-de-jiu-jitsu";
import AllCheckCategoriesCopaCianorteDeJiuJitsu from "./tournament/check-copa-cianorte-de-jiu-jitsu";
import AllCheckViReiDaPraiaDeJiuJitsuNoGi from "./tournament/check-vi-rei-da-praia-de-jiu-jitsu-no-gi";
import AllCheckIiCopaChampionsKidsDeJiuJitsu from "./tournament/check-ii-copa-champions-kids-de-jiu-jitsu";
import AllCheckIiiOpenRochaEMoraesDeJiuJitsu from "./tournament/check-iii-open-rocha-e-moraes-de-jiu-jitsu";
import AllCheckIOpenLaranjeirasDoSulDeJiuJitsu from "./tournament/check-i-open-laranjeira-do-sul-de-jiu-jitsu";
import AllCheckEstadualGfTeamAmazonasDeJiuJitsu from "./tournament/check-estadual-gf-team-amazonas-jiu-jitsu";
import AllCheckXxixCopaLuisNetoDeJiuJitsu from "./tournament/check-xxix-copa-luis-neto-jiu-jitsu";
import AllCheckEtapaOriximinaXxxiiCopaOrleyLobatoDeJiuJitsu from "./tournament/check-etapa-oriximina-xxxii-copa-orley-lobato-jiu-jitsu";
import AllCheckCampeonatoParintinsenseDeJiuJitsu from "./tournament/check-campeonato-parintinense-de-jiu-jitsu";
import AllCheckXviiiCopaParanaDeJiuJitsu from "./tournament/check-xviii-copa-parana-de-jiu-jitsu";
import AllCheckCopaInTheGuardDeJiuJitsu from "./tournament/check-copa-in-the-guard-de-jiu-jitsu";
import AllCheckCopaAmizadeDeJiuJitsu2025 from "./tournament/check-copa-amizade-de-jiu-jitsu-2025";
import AllCheckViiCopaCampeoesDeJiuJitsu2025 from "./tournament/check-vii-copa-campeoes-de-jiu-jitsu-2025";
import AllCheckCopaTorneioFacilDeJiuJitsu from "./tournament/check-copa-torneio-facil-de-jiu-jitsu";
import AllCheckCopaMercosulDeJiuJitsu from "./tournament/check-copa-mercosul-de-jiu-jitsu-2025";
import AllCheckCopaSantaTerezaDoOesteDeJiuJitsu from "./tournament/check-copa-santa-tereza-do-oeste-de-jiu-jitsu-2025";
import AllCheckIiOpenNhamundaDeJiuJitsu from "./tournament/check-ii-open-nhamunda-de-jiu-jitsu-2025";
import AllCheckVOpenTerraSantaDeJiuJitsu from "./tournament/check-v-open-terra-santa-de-jiu-jitsu-2025";
import AllCheckIiiCopaBjjCascavelDeJiuJitsu from "./tournament/check-iii-copa-bjj-cascavel-de-jiu-jitsu-2025";
import AllCheckIiCopaThomasiDeJiuJitsu2025 from "./tournament/check-ii-copa-thomasi-de-jiu-jitsu-2025";
import AllCheckOpenCandoiDeJiuJitsu from "./tournament/check-open-candoi-de-jiu-jitsu-2025";
import AllCheckCopaMestreDoAcaiDeJiuJitsu from "./tournament/check-copa-mestre-do-acai-de-jiu-jitsu-2025";
import AllCheckCopaFronteiraDeJiuJitsu2025 from "./tournament/check-copa-fronteira-de-jiu-jitsu-2025";
import AllCheckOpenCascavelInternationalDeJiuJitsu from "./tournament/check-open-cascavel-international-de-jiu-jitsu-2025";
import AllCheckIiCopaAquilesDeJiuJitsu from "./tournament/check-ii-copa-aquiles-de-jiu-jitsu-2025";
import AllCheckIValenteKidsDeJiuJitsu2025 from "./tournament/check-i-valente-kids-de-jiu-jitsu-2025";
import AllCheckICopaLeaoDeJudaDeJiuJitsu2025 from "./tournament/check-i-copa-leao-de-juda-de-jiu-jitsu-2025";
import AllCheckCopaLoboBravoCresolDeJiuJitsu2025 from "./tournament/check-copa-lobo-bravo-cresol-de-jiu-jitsu-2025";
import AllCheckXxxiiiCopaOrleyLobatoDeJiuJitsu from "./tournament/check-xxxiii-copa-orley-lobato-de-jiu-jitsu-2025";
import AllCheckOpenFiveDeJiuJitsu2025 from "./tournament/check-open-five-de-jiu-jitsu-2025";
import AllCheckViiiOpenAmazonasTopTeamDeJiuJitsu2025 from "./tournament/check-viii-open-amazonas-top-team-de-jiu-jitsu-2025";
import AllCheckIxReiERainhaDaPraiaBeachWrestling2025 from "./tournament/check-ix-rei-e-rainha-da-praia-beach-wrestiling-2025";
import AllCheckCopaCianorteDeJiuJitsu from "./tournament/check-copa-cianorte-de-jiu-jitsu";
import AllCheckCopaCianorteDeJiuJitsu2025 from "./tournament/check-copa-cianorte-de-jiu-jitsu-2025";
import AllCheckViiiLijjamCombatDeJiuJitsu2025 from "./tournament/check-viii-lijjam-combat-de-jiu-jitsu-2025";
import AllCheckLijjamCombatIxCombatDeJiuJitsu2026 from "./tournament/check-lijjam-combat-ix-de-jiu-jitsu-2026";
import AllCheckEstadualGfTeamDeJiuJitsu2025 from "./tournament/check-estadual-gfteam-amazonas-de-jiu-jitsu-2025";
import AllCheckICopaEuAmoParintinsDeJiuJitsu2025 from "./tournament/check-i-copa-eu-amo-parintins-de-jiu-jitsu-2025";
import AllCheckFozOpenConfrontoInternacionalDeJiuJitsu2025 from "./tournament/check-foz-open-confronto-internacional-de-jiu-jitsu-2025";
import AllCheckOpenChallengerDeJiuJitsu2025 from "./tournament/check-open-challenger-de-jiu-jitsu-2025";
import AllCheckViiReiDaPraiaDeJiuJitsu2025 from "./tournament/check-vii-rei-da-praia-de-jiu-jitsu-2025";
import AllCheckCopaMestreDoAcaiKidsDeJiuJitsu2025 from "./tournament/check-copa-mestre-do-acai-kids-de-jiu-jitsu-2025";
import AllCheckOpenParanavaiBrazilianDeJiuJitsu2025 from "./tournament/check-open-paranavai-brazilian-de-jiu-jitsu-2025";
import AllCheckNoroesteOpenDeJiuJitsu2025 from "./tournament/check-noroeste-open-de-jiu-jitsu-2025";
import AllCheckIvOpenParaguacuPaulistaDeJiuJitsu2025 from "./tournament/check-iv-open-paraguacu-paulista-de-jiu-jitsu-2025";
import AllCheckIiiCopaChampionsKidsECopaBushidoAdultoDeJiuJitsu2025 from "./tournament/check-iii-copa-champions-kids-e-i-copa-bushido-adulto-de-jiu-jitsu-2025";
import AllCheckOpenLaranjeirasDeJiuJitsu2025 from "./tournament/check-open-laranjeiras-do-sul-de-jiu-jitsu-2025";
import AllCheckToledoOpenBrazilianDeJiuJitsu2025 from "./tournament/check-toledo-open-brazilian-de-jiu-jitsu-2025";
import AllCheckCopaTomeyaSasaharaDeJiuJitsu2025 from "./tournament/check-copa-tomeya-sasahara-de-jiu-jitsu-2025";
import AllCheckICopaFaixaSolidariaDeJiuJitsu2025 from "./tournament/check-i-copa-faixa-solidaria-de-jiu-jitsu-2025";
import AllCheckCopaOpenExtremeManausDeJiuJitsu2025 from "./tournament/check-copa-open-extreme-manaus-de-jiu-jitsu-2025";
import AllCheckXiCopaLondrinaDeJiuJitsu2025 from "./tournament/check-xi-copa-londrina-de-jiu-jitsu-2025";
import AllCheckCopaArapongasDeJiuJitsu2026 from "./tournament/check-copa-arapongas-de-jiu-jitsu-2026";
import AllCheckXixCopaParanaDeJiuJitsu2026 from "./tournament/check-xix-copa-parana-de-jiu-jitsu-2026";
import AllCheckCircuitoInternacionalDeJiuJitsu2026 from "./tournament/check-circuito-internacional-de-jiu-jitsu-2026";
import AllCheckCopaParintinenseDeJiuJitsu2026 from "./tournament/check-copa-parintinense-de-jiu-jitsu-2026";
import AllCheckIiCopaMercosulDeJiuJitsu2026 from "./tournament/check-ii-copa-mercosul-de-jiu-jitsu-2026";
import AllCheckStiOpenKidsDeJiuJitsu2026 from "./tournament/check-sti-open-kids-de-jiu-jitsu-2026";
import AllCheckCampeonatoDeJiuJitsuGladiadoresAbleBjjJudo2026 from "./tournament/check-campeonato-de-jiu-jitsu-gladiadores-able-bjj-judo-2026";
import AllCheckIGrandSlamEstadualDeJiuJitsuFeminino2026 from "./tournament/check-i-grand-slam-estadual-de-jiu-jitsu-feminino-2026";
import AllCheckViiiCopaCampeoesDeJiuJitsu2026 from "./tournament/check-viii-copa-campeoes-de-jiu-jitsu-2026";
import AllCheckSeletivaManausOlimpicaDeJiuJitsu2026 from "./tournament/check-seletiva-manaus-olimpica-de-jiu-jitsu-2025";
import AllCheckCopaAmizadeDeJiuJitsu2026 from "./tournament/check-copa-amizade-de-jiu-jitsu-2026";
import AllCheckIvCopaClbjjDeJiuJitsu2026 from "./tournament/check-iv-copa-clbjj-de-jiu-jitsu-2026";
import AllCheckICopaBjjTalentDeJiuJitsu2026 from "./tournament/check-i-copa-bjj-talent-de-jiu-jitsu-2026";
import AllCheckOpenFiveDeJiuJitsu2026 from "./tournament/check-open-five-de-jiu-jitsu-2026";
import AllCheckCircuitoFajjeCoariDeJiuJitsuCoariAm from "./tournament/check-circuito-fajje-coari-de-jiu-jitsu-coari-am";
import AllCheckICircuitoAmazonenseFajjoManausAm from "./tournament/check-i-circuito-amazonense-fajjo-manaus-am";
import AllCheckOpenCambeDeJiuJitsu2026 from "./tournament/check-open-cambe-de-jiu-jitsu-2026";
import AllCheckICampeonatoAmazonenseDeMmaAmador2026 from "./tournament/check-i-campeonato-amazonense-de-mma-amador-2026";
import AllCheckDesafioZonaNorteDeJiuJitsuManausAm2026 from "./tournament/check-desafio-zona-norte-de-jiu-jitsu-manaus-am-2026";
import AllCheckIiCopaBushidoDeJiuJitsu2026 from "./tournament/check-ii-copa-bushido-de-jiu-jitsu-2026";
import AllCheckViOpenTerraSantaDeJiuJitsu2026 from "./tournament/check-vi-open-terra-santa-de-jiu-jitsu-2026";
import AllCheckICampeonatoInternoCtTeamKombatDeJiuJitsu2026 from "./tournament/check-i-campeonato-interno-ct-team-kombat-de-jiu-jitsu-2026";
import AllCheckIiOpenChallengerDeJiuJitsu2026 from "./tournament/check-ii-open-challenger-de-jiu-jitsu-2026";
import AllCheckXxxivCopaOrleyLobatoDeJiuJitsu2026 from "./tournament/check-xxxiv-copa-orley-lobato-de-jiu-jitsu-2026";


function AllCheck() {
  const { slug } = useParams();
  switch (slug) {
    // case "seletiva-manaus-olimpica-2024-ginasio-ninimberg-guerra-sao-jorge-manaus-am":
    case "i-rei-e-rainha-da-praia-beach-boxing-manaus-amazonas-2023-manaus-amazonas":
      return <AllCheckSeletivaManausOlimpica2024 />;
    case "viii-rei-e-rainha-da-praia-beach-wrestling-2024-nossa-praia-sports":
      return <AllCheckViiiReiERainhaDaPraiaBeachWrestilingManausAmazonas2024 />;
    case "copa-mestre-acai-de-jiu-jitsu-2024-ginasio-arrudao-francisco-beltao-pr":
    case "xvii-copa-parana-de-jiu-jitsu-ginasio-de-esportes-alcides-pan-toledo-pr-gi":
    case "xvii-copa-parana-de-jiu-jitsu-ginasio-de-esportes-alcides-pan-toledo-pr-nogi":
      return <AllCheckCopaMestreAcaiDeJiuJitsu2024 />;
    case "xxxii-copa-orley-lobato-de-jiu-jitsu-cel-nininberg-guerra-manaus-am":
    case "ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-gi":
    case "ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-nogi":
    case "i-copa-thomasi-de-jiu-jitsu-parque-do-japao-maringa-pr":
    case "iv-opem-terra-santa-de-jiu-jistu-ginasio-braulio-nelson-da-conceicao-gi":
    case "iv-opem-terra-santa-de-jiu-jistu-ginasio-braulio-nelson-da-conceicao-nogi":
      return <AllCheckXxxiiCopaOrleyLobatoDeJiuJitsu />;
    case "i-orixicombat-open-jiu-jitsu-ginasio-municipal-de-oriximina-pa":
      return <AllCheckIOrixicombatOpenJiuJitsu />;
    case "copa-amizade-de-jiu-jitsu-2024-ginasio-de-esportes-amario-vieira-da-costa-umuarama-pr":
    case "copa-fronteira-de-jiu-jitsu-ginasio-de-esportes-amario-vieira-da-costa-umuarama-pr":
      return <AllCheckJiuJitsuLaranjaEVerdeJuntos />;
    case "copa-lobo-bravo-cresol-de-jiu-jitsu-ginasio-assuncao-de-nossa-senhora-guarapuava-pr":
      return <AllCheckCopaLoboBravoCresolDeJiuJitsu />;
    case "old-iv-opem-terra-santa-de-jiu-jistu-ginasio-braulio-nelson-da-conceicao-gi":
      return <AllCheckIvOpenTerraSantaDeJiuJitsu />;
    case "vii-open-amazonas-top-team-de-jiu-jitsu-manaus-am-gi":
      return <AllCheckViiOpenAmazonasTopTeamDeJiuJitsu />;
    case "copa-cianorte-de-jiu-jitsu-cianorte-pr-gi":
      return <AllCheckCategoriesCopaCianorteDeJiuJitsu />;
    case "vi-rei-da-praia-de-jiu-jitsu-santarem-pa-nogi":
      return <AllCheckViReiDaPraiaDeJiuJitsuNoGi />;
    case "ii-copa-champions-kids-de-jiu-jitsu-maringa-pr-gi":
      return <AllCheckIiCopaChampionsKidsDeJiuJitsu />;
    case "iii-open-rocha-e-moraes-de-jiu-jitsu-manaus-am-gi":
      return <AllCheckIiiOpenRochaEMoraesDeJiuJitsu />;
    case "i-open-laranjeiras-do-sul-de-jiu-jitsu-laranjeiras-pr-gi":
      return <AllCheckIOpenLaranjeirasDoSulDeJiuJitsu />;
    case "estadual-gf-team-amazonas-jiu-jitsu-manaus-am-gi":
    case "estadual-gf-team-amazonas-jiu-jitsu-manaus-am-nogi":
      return <AllCheckEstadualGfTeamAmazonasDeJiuJitsu />;
    case "xxix-copa-luis-neto-jiu-jitsu-manaus-am-gi":
    case "xxix-copa-luis-neto-jiu-jitsu-manaus-am-nogi":
    case "copa-manacapuru-de-jiu-jitsu-mananacapuru-am-gi":
    case "copa-manacapuru-de-jiu-jitsu-mananacapuru-am-nogi":
      return <AllCheckXxixCopaLuisNetoDeJiuJitsu />;
    case "etapa-oriximina-xxxii-copa-orley-lobato-jiu-jitsu-oriximina-pa-gi":
    case "etapa-oriximina-xxxii-copa-orley-lobato-jiu-jitsu-oriximina-pa-nogi":
      return <AllCheckEtapaOriximinaXxxiiCopaOrleyLobatoDeJiuJitsu />;
    case "campeonato-parintinense-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-gi":
    case "campeonato-parintinense-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-nogi":
    case "seletiva-manaus-olimpica-2024-ginasio-ninimberg-guerra-sao-jorge-manaus-am":
      return <AllCheckCampeonatoParintinsenseDeJiuJitsu />;
    case "xviii-copa-parana-de-jiu-jitsu-cascavel-pr-gi":
    case "xviii-copa-parana-de-jiu-jitsu-cascavel-pr-nogi":
      return <AllCheckXviiiCopaParanaDeJiuJitsu />;
    case "copa-in-the-guard-de-jiu-jitsu-cascavel-pr-gi":
      return <AllCheckCopaInTheGuardDeJiuJitsu />;
    case "copa-amizade-de-jiu-jitsu-2025-umuarama-pr-gi":
      return <AllCheckCopaAmizadeDeJiuJitsu2025 />;
    case "vii-copa-campeoes-de-jiu-jitsu-maringa-pr-gi":
      return <AllCheckViiCopaCampeoesDeJiuJitsu2025 />;
    case "copa-torneio-facil-de-jiu-jitsu-manaus-am-gi":
    case "copa-torneio-facil-de-jiu-jitsu-manaus-am-nogi":
      return <AllCheckCopaTorneioFacilDeJiuJitsu />;
    case "copa-mercosul-de-jiu-jitsu-foz-do-iguacu-pr-gi":
      return <AllCheckCopaMercosulDeJiuJitsu />;
    case "copa-santa-tereza-do-oeste-de-jiu-jitsu-santa-tereza-do-oeste-pr-gi":
      return <AllCheckCopaSantaTerezaDoOesteDeJiuJitsu />;
    case "ii-open-nhamunda-de-jiu-jitsu-nhamunda-am-gi":
    case "ii-open-nhamunda-de-jiu-jitsu-nhamunda-am-nogi":
    case "ii-open-nhamunda-de-jiu-jitsu-nhamunda-am-gi-absoluto":
    case "ii-open-nhamunda-de-jiu-jitsu-nhamunda-am-nogi-absoluto":
      return <AllCheckIiOpenNhamundaDeJiuJitsu />;
    case "v-open-terra-santa-de-jiu-jitsu-2025-terra-santa-pa-gi":
    case "v-open-terra-santa-de-jiu-jitsu-2025-terra-santa-pa-nogi":
      return <AllCheckVOpenTerraSantaDeJiuJitsu />;
    case "iii-copa-bjj-cascavel-de-jiu-jitsu-cascavel-pr-gi":
    case "iii-copa-bjj-cascavel-de-jiu-jitsu-cascavel-pr-nogi":
      return <AllCheckIiiCopaBjjCascavelDeJiuJitsu />;
    case "ii-copa-thomasi-de-jiu-jitsu-maringa-pr-gi":
      return <AllCheckIiCopaThomasiDeJiuJitsu2025 />;
    case "open-candoi-de-jiu-jitsu-candoi-centro-sul-pr-gi":
      return <AllCheckOpenCandoiDeJiuJitsu />;
    case "copa-mestre-do-acai-de-jiu-jitsu-francisco-beltrao-pr-gi":
    case "copa-mestre-do-acai-de-jiu-jitsu-francisco-beltrao-pr-nogi":
      return <AllCheckCopaMestreDoAcaiDeJiuJitsu />;
    case "copa-fronteira-de-jiu-jitsu-2025-umuarama-pr-gi":
      return <AllCheckCopaFronteiraDeJiuJitsu2025 />;
    case "open-cascavel-international-de-jiu-jitsu-cascavel-pr-gi":
    case "open-cascavel-international-de-jiu-jitsu-cascavel-pr-nogi":
      return <AllCheckOpenCascavelInternationalDeJiuJitsu />;
    case "ii-copa-aquiles-de-jiu-jitsu-foz-do-iguacu-pr-gi":
      return <AllCheckIiCopaAquilesDeJiuJitsu />;
    case "i-valente-kids-de-jiu-jitsu-nova-olimpia-pr-gi":
      return <AllCheckIValenteKidsDeJiuJitsu2025 />;
    case "i-copa-leao-de-juda-de-jiu-jitsu-mandaguari-pr-gi":
      return <AllCheckICopaLeaoDeJudaDeJiuJitsu2025 />;
    case "copa-lobo-bravo-cresol-de-jiu-jitsu-guarapuava-pr-gi":
      return <AllCheckCopaLoboBravoCresolDeJiuJitsu2025 />;
    case "xxxiii-copa-orley-lobato-de-jiu-jitsu-manaus-am-gi":
    case "xxxiii-copa-orley-lobato-de-jiu-jitsu-manaus-am-absoluto":
      return <AllCheckXxxiiiCopaOrleyLobatoDeJiuJitsu />;
    case "open-five-de-jiu-jitsu-londrina-pr-gi":
    case "open-five-de-jiu-jitsu-londrina-pr-nogi":
      return <AllCheckOpenFiveDeJiuJitsu2025 />;
    case "viii-open-amazonas-top-team-de-jiu-jitsu-manaus-am-gi":
    case "viii-open-amazonas-top-team-de-jiu-jitsu-manaus-am-nogi":
      return <AllCheckViiiOpenAmazonasTopTeamDeJiuJitsu2025 />;
    case "ix-rei-e-rainha-da-praia-beach-wrestiling-2025-manaus-am":
      return <AllCheckIxReiERainhaDaPraiaBeachWrestling2025 />;
    case "copa-cianorte-de-jiu-jitsu-2025-cianorte-pr-gi":
      return <AllCheckCopaCianorteDeJiuJitsu2025 />;
    case "viii-lijjam-combat-de-jiu-jitsu-manaus-am-gi":
    case "viii-lijjam-combat-de-jiu-jitsu-manaus-am-nogi":
      return <AllCheckViiiLijjamCombatDeJiuJitsu2025 />;
    case "lijjam-combat-ix-de-jiu-jitsu-manaus-am-gi":
    case "lijjam-combat-ix-de-jiu-jitsu-manaus-am-nogi":
      return <AllCheckLijjamCombatIxCombatDeJiuJitsu2026 />;
    case "estadual-gfteam-amazonas-de-jiu-jitsu-manaus-am-gi":
    case "estadual-gfteam-amazonas-de-jiu-jitsu-manaus-am-nogi":
      return <AllCheckEstadualGfTeamDeJiuJitsu2025 />;
    case "i-copa-eu-amo-parintins-de-jiu-jitsu-parintins-am-gi":
    case "i-copa-eu-amo-parintins-de-jiu-jitsu-parintins-am-absoluto":
      return <AllCheckICopaEuAmoParintinsDeJiuJitsu2025 />;
    case "foz-open-confronto-internacional-de-jiu-jitsu-foz-do-iguacu-pr-gi":
      return <AllCheckFozOpenConfrontoInternacionalDeJiuJitsu2025 />;
    case "open-challenger-de-jiu-jitsu-manaus-am-gi":
    case "open-challenger-de-jiu-jitsu-manaus-am-nogi":
      return <AllCheckOpenChallengerDeJiuJitsu2025 />;
    case "vii-rei-da-praia-de-jiu-jitsu-santarem-pa-nogi":
      return <AllCheckViiReiDaPraiaDeJiuJitsu2025 />;
    case "copa-mestre-do-acai-de-kids-jiu-jitsu-francisco-beltrao-pr-gi":
      return <AllCheckCopaMestreDoAcaiKidsDeJiuJitsu2025 />;
    case "open-paranavai-brazilian-de-jiu-jitsu-paranavai-pr-gi":
    case "open-paranavai-brazilian-de-jiu-jitsu-paranavai-pr-nogi":
      return <AllCheckOpenParanavaiBrazilianDeJiuJitsu2025 />;
    case "noroeste-open-de-jiu-jitsu-2025-umuarama-pr-gi":
    case "noroeste-open-de-jiu-jitsu-2025-umuarama-pr-nogi":
      return <AllCheckNoroesteOpenDeJiuJitsu2025 />;
    case "iv-open-paraguacu-paulista-de-jiu-jitsu-paraguacu-paulista-sp-gi":
    case "iv-open-paraguacu-paulista-de-jiu-jitsu-paraguacu-paulista-sp-nogi":
      return <AllCheckIvOpenParaguacuPaulistaDeJiuJitsu2025 />;
    case "iii-copa-champions-kids-e-i-copa-bushido-adulto-de-jiu-jitsu-maringa-pr-gi":
      return <AllCheckIiiCopaChampionsKidsECopaBushidoAdultoDeJiuJitsu2025 />;
    case "open-laranjeiras-do-sul-de-jiu-jitsu-laranjeiras-do-sul-pr-gi":
      return <AllCheckOpenLaranjeirasDeJiuJitsu2025 />;
    case "toledo-open-brazilian-de-jiu-jitsu-toledo-pr-gi":
    case "toledo-open-brazilian-de-jiu-jitsu-toledo-pr-nogi":
      return <AllCheckToledoOpenBrazilianDeJiuJitsu2025 />;
    case "copa-tomeya-sasahara-de-jiu-jitsu-umuarama-pr-gi":
      return <AllCheckCopaTomeyaSasaharaDeJiuJitsu2025 />;
    case "i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-gi":
      return <AllCheckICopaFaixaSolidariaDeJiuJitsu2025 />;
    case "copa-open-extreme-manaus-de-jiu-jitsu-manaus-am-gi":
      return <AllCheckCopaOpenExtremeManausDeJiuJitsu2025 />;
    case "xi-copa-londrina-de-jiu-jitsu-londrina-pr-gi":
      return <AllCheckXiCopaLondrinaDeJiuJitsu2025 />;
    case "copa-arapongas-de-jiu-jitsu-arapongas-pr-gi":
      return <AllCheckCopaArapongasDeJiuJitsu2026 />;
    case "xix-copa-parana-de-jiu-jitsu-cascavel-pr-gi":
    case "xix-copa-parana-de-jiu-jitsu-cascavel-pr-nogi":
      return <AllCheckXixCopaParanaDeJiuJitsu2026 />;
    case "circuito-internacional-de-jiu-jitsu-cascavel-pr-gi":
    case "circuito-internacional-de-jiu-jitsu-cascavel-pr-nogi":
      return <AllCheckCircuitoInternacionalDeJiuJitsu2026 />;
    case "copa-parintinense-de-jiu-jitsu-parintins-am-gi":
    case "copa-parintinense-de-jiu-jitsu-parintins-am-nogi":
      return <AllCheckCopaParintinenseDeJiuJitsu2026 />;
    case "ii-copa-mercosul-de-jiu-jitsu-foz-do-iguacu-pr-gi":
    case "ii-copa-mercosul-de-jiu-jitsu-foz-do-iguacu-pr-nogi":
      return <AllCheckIiCopaMercosulDeJiuJitsu2026 />;
    case "sti-open-kids-de-jiu-jitsu-santa-terezinha-de-itaipu-pr-gi":
    case "sti-open-kids-de-jiu-jitsu-santa-terezinha-de-itaipu-pr-nogi":
      return <AllCheckStiOpenKidsDeJiuJitsu2026 />;
    case "campeonato-de-jiu-jitsu-gladiadores-able-bjj-judo-manaus-am-gi":
      return <AllCheckCampeonatoDeJiuJitsuGladiadoresAbleBjjJudo2026 />;
    case "i-grand-slam-estadual-de-jiu-jitsu-santarem-pa-gi":
      return <AllCheckIGrandSlamEstadualDeJiuJitsuFeminino2026 />;
    case "viii-copa-campeoes-de-jiu-jitsu-maringa-pr-gi":
      return <AllCheckViiiCopaCampeoesDeJiuJitsu2026 />;
    case "seletiva-manaus-olimpica-2026-ginasio-ninimberg-guerra-sao-jorge-manaus-am":
      return <AllCheckSeletivaManausOlimpicaDeJiuJitsu2026 />;
    case "copa-amizade-de-jiu-jitsu-2026-umuarama-pr-gi":
      return <AllCheckCopaAmizadeDeJiuJitsu2026 />;
    case "iv-copa-clbjj-de-jiu-jitsu-manaus-am-gi":
    case "iv-copa-clbjj-de-jiu-jitsu-manaus-am-nogi":
      return <AllCheckIvCopaClbjjDeJiuJitsu2026 />;
    case "i-copa-bjj-talent-de-jiu-jitsu-manaus-am-gi":
    case "i-copa-bjj-talent-de-jiu-jitsu-manaus-am-nogi":
      return <AllCheckICopaBjjTalentDeJiuJitsu2026 />;
    case "open-five-de-jiu-jitsu-curiuva-pr-gi":
      return <AllCheckOpenFiveDeJiuJitsu2026 />;
    case "circuito-fajje-coari-de-jiu-jitsu-coari-am-gi":
    case "circuito-fajje-coari-de-jiu-jitsu-coari-am-nogi":
      return <AllCheckCircuitoFajjeCoariDeJiuJitsuCoariAm />;
    case "i-circuito-amazonense-fajjo-manaus-am-gi":
    case "i-circuito-amazonense-fajjo-manaus-am-nogi":
      return <AllCheckICircuitoAmazonenseFajjoManausAm />;
    case "open-cambe-de-jiu-jitsu-cambe-pr-gi":
      return <AllCheckOpenCambeDeJiuJitsu2026 />;
    case "i-campeonato-amazonense-de-mma-amador-manaus-am":
      return <AllCheckICampeonatoAmazonenseDeMmaAmador2026 />;
    case "desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-gi":
    case "desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-nogi":
      return <AllCheckDesafioZonaNorteDeJiuJitsuManausAm2026 />;
    case "ii-copa-bushido-de-jiu-jitsu-maringa-pr-gi":
      return <AllCheckIiCopaBushidoDeJiuJitsu2026 />;
    case "vi-open-terra-santa-de-jiu-jitsu-terra-santa-pa-gi":
    case "vi-open-terra-santa-de-jiu-jitsu-terra-santa-pa-nogi":
      return <AllCheckViOpenTerraSantaDeJiuJitsu2026 />;
    case "i-campeonato-interno-ct-kombat-de-jiu-jitsu-foz-do-iguacu-pr-gi":
      return <AllCheckICampeonatoInternoCtTeamKombatDeJiuJitsu2026 />;
    case "ii-open-challenger-de-jiu-jitsu-manaus-am-gi":
    case "ii-open-challenger-de-jiu-jitsu-manaus-am-nogi":
      return <AllCheckIiOpenChallengerDeJiuJitsu2026 />;
    case "xxxiv-copa-orley-lobato-de-jiu-jitsu-manaus-am-gi":
      return <AllCheckXxxivCopaOrleyLobatoDeJiuJitsu2026 />;

    default:
      return <h1>Checagem não liberada para esse torneio</h1>;
  }
}

export default AllCheck;
